/* eslint-env browser */
import inherit from 'component-inherit';
import Query from './query';

const ua = navigator.userAgent.toLowerCase();

/**
 * Creates an IE instance
 */

export default function IE() {
  if (!(this instanceof IE)) {
    return new IE();
  }

  this.name = 'Internet Explorer';
  this.uaname = 'msie';
  this.version = ua.indexOf(this.uaname) != -1 ? parseInt(ua.split(this.uaname)[1]) : false;
}

/**
 * Inherits IE from Query
 */

inherit(IE, Query);



// WEBPACK FOOTER //
// ./src/modules/npm-component/user-agent/ie.js